import { __awaiter } from "tslib";
import React from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { Form, Input, Radio, DatePicker, Select, Checkbox, Button, Icon } from 'antd';
import configStyle from '../_style/reportConfig.less';
import { RowCol, QuarterPicker } from '@/components';
import moment from 'moment';
import ReportModal from './ReportModal';
import { dealDateToTableData } from './function';
import { setKey } from '@/shared/functions';
import { CHECK_name } from '@/shared/reqexp';
const mapStateToProps = (rootState) => {
    return {
        report: rootState.reportCreate,
    };
};
const SessionItem = (props) => {
    return (<div className={configStyle.session_item} key={props.key}>
      <span>场次：{props.sessionCode}</span>
      <Icon className={configStyle.session_close} type="close" onClick={props.onClick}/>
    </div>);
};
class ReportConfig extends React.Component {
    constructor(props) {
        super(props);
        this.yesterdayDate = null;
        this.state = {
            dataType: null,
            dateType: null,
            dataDimensionList: [
                {
                    value: 1,
                    name: '租户',
                },
                {
                    value: 2,
                    name: '场次',
                },
                {
                    value: 3,
                    name: '车商',
                },
            ],
            statisticalDimensionList: [
                {
                    value: 1,
                    name: '按天',
                },
                {
                    value: 2,
                    name: '按周',
                },
                {
                    value: 3,
                    name: '按月',
                },
                {
                    value: 4,
                    name: '按季度',
                },
            ],
        };
        this.changeDataType = this.changeDataType.bind(this);
        this.renderSession = this.renderSession.bind(this);
        this.renderTanant = this.renderTanant.bind(this);
        this.renderCheckGroup = this.renderCheckGroup.bind(this);
        this.changeDateType = this.changeDateType.bind(this);
        this.dealDateToTableData = this.dealDateToTableData.bind(this);
        this.changeTableShow = this.changeTableShow.bind(this);
        this.queryCarBusinessData = this.queryCarBusinessData.bind(this);
        this.memoryDataFn = this.memoryDataFn.bind(this);
    }
    componentDidMount() {
        dispatch.reportCreate.getSessionType({});
    }
    // desc 日禁选
    banDay(currentDate) {
        const today = moment();
        return !currentDate.isBefore(today, 'day');
    }
    // desc 日期选择
    renderDay(onChange, disabled) {
        const { getFieldDecorator, validateFields } = this.props.form;
        const { dataDimension } = this.props.report;
        const memoryData = this.props.report[`memoryData${dataDimension}`];
        const startTime = memoryData.formData[`startTime${dataDimension}1`];
        const endTime = memoryData.formData[`endTime${dataDimension}1`];
        return (<>
        {getFieldDecorator(`startTime${dataDimension}1`, {
            initialValue: startTime ? moment(startTime) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        const endTime = this.props.form.getFieldsValue([`endTime${dataDimension}1`])[`endTime${dataDimension}1`];
                        if (!value || (endTime ? value.isBefore(endTime) : true)) {
                            endTime && validateFields([`endTime${dataDimension}1`]);
                            callback();
                        }
                        else {
                            callback('开始时间必须早于结束时间');
                        }
                    },
                },
            ],
        })(<DatePicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} disabled={disabled} disabledDate={this.banDay} onChange={onChange} style={{ width: '200px' }} placeholder={'开始时间'} showToday={false}/>)}
        <span style={{ color: '#8D8E99', margin: '0 5px' }}>～</span>
        <Form.Item label={''} style={{
            marginBottom: 0,
            display: 'inline-block',
            height: '40px',
            overflow: 'visible',
        }}>
          {getFieldDecorator(`endTime${dataDimension}1`, {
            initialValue: endTime ? moment(endTime) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择结束时间',
                },
                {
                    validator: (rule, value, callback) => {
                        const beginDate = this.props.form.getFieldsValue([`startTime${dataDimension}1`])[`startTime${dataDimension}1`];
                        if (!value || (beginDate ? value.isAfter(beginDate) : true)) {
                            beginDate && validateFields([`startTime${dataDimension}1`]);
                            callback();
                        }
                        else {
                            callback('结束时间必须晚于开始时间');
                        }
                    },
                },
            ],
        })(<DatePicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} disabled={disabled} disabledDate={this.banDay} onChange={onChange} style={{ width: '200px' }} placeholder={'结束时间'} showToday={false}/>)}
        </Form.Item>
      </>);
    }
    // desc 周禁选
    banWeek(currentDate) {
        const today = moment();
        const isSunday = today.day() === 0;
        const todayMonday = isSunday ? today.day(1 - 7) : today.day(1);
        return !currentDate.isBefore(todayMonday, 'day');
    }
    // desc 周选择
    renderWeek(onChange, disabled) {
        const { getFieldDecorator, validateFields } = this.props.form;
        const { dataDimension } = this.props.report;
        const memoryData = this.props.report[`memoryData${dataDimension}`];
        const startTime = memoryData.formData[`startTime${dataDimension}2`];
        const endTime = memoryData.formData[`endTime${dataDimension}2`];
        return (<>
        {getFieldDecorator(`startTime${dataDimension}2`, {
            initialValue: startTime ? moment(startTime) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        const weekEnd = this.props.form.getFieldsValue([`endTime${dataDimension}2`])[`endTime${dataDimension}2`];
                        if (weekEnd) {
                            const isSunday = weekEnd.day() === 0;
                            const weekEndDate = isSunday ? weekEnd : moment(weekEnd).day(7);
                            if (!value || (weekEnd ? (value.isBefore(weekEndDate) || value.isSame(weekEndDate, 'day')) : true)) {
                                weekEnd && validateFields([`endTime${dataDimension}2`]);
                                callback();
                            }
                            else {
                                console.log('end', weekEndDate);
                                console.log('value', value);
                                callback('开始时间必须早于结束时间');
                            }
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
        })(<DatePicker.WeekPicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} disabled={disabled} disabledDate={this.banWeek} onChange={onChange} style={{ width: '200px' }} placeholder={'开始时间'}/>)}
        <span style={{ color: '#8D8E99', margin: '0 5px' }}>～</span>
        <Form.Item label={''} style={{
            marginBottom: 0,
            display: 'inline-block',
            height: '40px',
            overflow: 'visible',
        }}>
          {getFieldDecorator(`endTime${dataDimension}2`, {
            initialValue: endTime ? moment(endTime) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择结束时间',
                },
                {
                    validator: (rule, value, callback) => {
                        const weekBegin = this.props.form.getFieldsValue([`startTime${dataDimension}2`])[`startTime${dataDimension}2`];
                        if (weekBegin) {
                            const isSunday = weekBegin.day() === 0;
                            const weekBeginDate = isSunday ? moment(weekBegin).day(1 - 7) : moment(weekBegin).day(1);
                            // moment周概念为：周日～周一  项目所需为 周一～周日
                            if (!value || (weekBegin ? (value.isAfter(weekBeginDate) || value.isSame(weekBeginDate, 'day')) : true)) {
                                weekBegin && validateFields([`startTime${dataDimension}2`]);
                                callback();
                            }
                            else {
                                console.log(weekBeginDate, value);
                                callback('结束时间必须晚于开始时间');
                            }
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
        })(<DatePicker.WeekPicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} disabled={disabled} disabledDate={this.banWeek} onChange={onChange} style={{ width: '200px' }} placeholder={'结束时间'}/>)}
        </Form.Item>
      </>);
    }
    // desc 月禁选
    banMonth(currentDate) {
        const today = moment();
        return !currentDate.isBefore(today, 'month');
    }
    // desc 月选择
    renderMonth(onChange, disabled) {
        const { getFieldDecorator, validateFields } = this.props.form;
        const { dataDimension } = this.props.report;
        const memoryData = this.props.report[`memoryData${dataDimension}`];
        const startTime = memoryData.formData[`startTime${dataDimension}3`];
        const endTime = memoryData.formData[`endTime${dataDimension}3`];
        return (<>
        {getFieldDecorator(`startTime${dataDimension}3`, {
            initialValue: startTime ? moment(startTime) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        const endTime = this.props.form.getFieldsValue([`endTime${dataDimension}3`])[`endTime${dataDimension}3`];
                        if (!value || (endTime ? (value.isBefore(endTime, 'month') || value.isSame(endTime, 'month')) : true)) {
                            endTime && validateFields([`endTime${dataDimension}3`]);
                            callback();
                        }
                        else {
                            callback('开始时间必须早于结束时间');
                        }
                    },
                },
            ],
        })(<DatePicker.MonthPicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} disabled={disabled} disabledDate={this.banMonth} onChange={onChange} style={{ width: '200px' }} placeholder={'开始时间'}/>)}
        <span style={{ color: '#8D8E99', margin: '0 5px' }}>～</span>
        <Form.Item label={''} style={{
            marginBottom: 0,
            display: 'inline-block',
            height: '40px',
            overflow: 'visible',
        }}>
          {getFieldDecorator(`endTime${dataDimension}3`, {
            initialValue: endTime ? moment(endTime) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择结束时间',
                },
                {
                    validator: (rule, value, callback) => {
                        const beginDate = this.props.form.getFieldsValue([`startTime${dataDimension}3`])[`startTime${dataDimension}3`];
                        if (!value || (beginDate ? (value.isAfter(beginDate, 'month') || value.isSame(beginDate, 'month')) : true)) {
                            beginDate && validateFields([`startTime${dataDimension}3`]);
                            callback();
                        }
                        else {
                            callback('结束时间必须晚于开始时间');
                        }
                    },
                },
            ],
        })(<DatePicker.MonthPicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} disabled={disabled} disabledDate={this.banMonth} onChange={onChange} style={{ width: '200px' }} placeholder={'结束时间'}/>)}
        </Form.Item>
      </>);
    }
    // desc 季度选择
    renderQuarter(onChange) {
        const { getFieldDecorator, validateFields } = this.props.form;
        const { dataDimension } = this.props.report;
        const memoryData = this.props.report[`memoryData${dataDimension}`];
        const startTime = memoryData.formData[`startTime${dataDimension}4`];
        const endTime = memoryData.formData[`endTime${dataDimension}4`];
        return (<>
        {getFieldDecorator(`startTime${dataDimension}4`, {
            initialValue: startTime ? {
                year: moment(startTime).year(),
                quarter: moment(startTime).quarter(),
            } : {},
            rules: [
                {
                    required: true,
                    message: '请选择开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        const currentYear = value.year;
                        const currentQuarter = value.quarter;
                        const currentDate = currentYear ? moment(`${currentYear}`).quarter(currentQuarter) : undefined;
                        const { year, quarter } = this.props.form.getFieldsValue([`endTime${dataDimension}4`])[`endTime${dataDimension}4`];
                        const endDate = year ? moment(`${year}`).quarter(quarter) : undefined;
                        if (currentDate) {
                            if (endDate ? (currentDate.isBefore(endDate, 'quarter') || currentDate.isSame(endDate, 'quarter')) : true) {
                                endDate && validateFields([`endTime${dataDimension}4`]);
                                callback();
                            }
                            else {
                                callback('开始时间必须早于结束时间');
                            }
                        }
                        else {
                            callback('请选择开始时间');
                        }
                    },
                },
            ],
        })(<QuarterPicker onChange={onChange} disableAfterQuarter={true} style={{ width: '200px', display: 'inline-block' }} placeholder={'开始时间'}/>)}
        <span style={{ color: '#8D8E99', margin: '0 5px' }}>～</span>
        <Form.Item label={''} style={{
            marginBottom: 0,
            display: 'inline-block',
            height: '40px',
            overflow: 'visible',
        }}>
          {getFieldDecorator(`endTime${dataDimension}4`, {
            initialValue: endTime ? {
                year: moment(endTime).year(),
                quarter: moment(endTime).quarter(),
            } : {},
            rules: [
                {
                    validator: (rule, value, callback) => {
                        const currentYear = value.year;
                        const currentQuarter = value.quarter;
                        const currentDate = currentYear ? moment(`${currentYear}`).quarter(currentQuarter) : undefined;
                        const { year, quarter } = this.props.form.getFieldsValue([`startTime${dataDimension}4`])[`startTime${dataDimension}4`];
                        const beginDate = year ? moment(`${year}`).quarter(quarter) : undefined;
                        if (currentDate) {
                            if (beginDate ? (currentDate.isAfter(beginDate, 'quarter') || currentDate.isSame(beginDate, 'quarter')) : true) {
                                beginDate && validateFields([`startTime${dataDimension}4`]);
                                callback();
                            }
                            else {
                                callback('结束时间必须晚于开始时间');
                            }
                        }
                        else {
                            callback('请选择结束时间');
                        }
                    },
                },
            ],
        })(<QuarterPicker onChange={onChange} disableAfterQuarter={true} style={{ width: '200px', display: 'inline-block' }} placeholder={'结束时间'}/>)}
        </Form.Item>
      </>);
    }
    // desc 处理日期展示表格数据 - 日期change的时候
    dealDateToTableData() {
        setTimeout(() => {
            const { dataDimension } = this.props.report;
            const memoryData = this.props.report[`memoryData${dataDimension}`];
            const { statisticalDimension = 1 } = memoryData.formData;
            const startTime = this.props.form.getFieldsValue([`startTime${dataDimension}${statisticalDimension}`])[`startTime${dataDimension}${statisticalDimension}`];
            const endTime = this.props.form.getFieldsValue([`endTime${dataDimension}${statisticalDimension}`])[`endTime${dataDimension}${statisticalDimension}`];
            let tableData = [];
            if (startTime && endTime) {
                tableData = dealDateToTableData({
                    start: startTime,
                    end: endTime,
                    dateType: statisticalDimension,
                });
            }
            dispatch.reportCreate.SET_STATE({
                preViewTableData: tableData,
                [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                    tableData,
                }),
            });
        });
    }
    // desc 数据维度：租户
    renderTanant() {
        const { getFieldDecorator } = this.props.form;
        const { sessionType = [], memoryData1, } = this.props.report;
        const { statisticalDimension = 1, auctionMode } = memoryData1.formData;
        const { statisticalDimensionList } = this.state;
        let DateSelect;
        switch (statisticalDimension) {
            case 1:
                DateSelect = this.renderDay(this.dealDateToTableData);
                break;
            case 2:
                DateSelect = this.renderWeek(this.dealDateToTableData);
                break;
            case 3:
                DateSelect = this.renderMonth(this.dealDateToTableData);
                break;
            case 4:
                DateSelect = this.renderQuarter(this.dealDateToTableData);
                break;
            default:
                DateSelect = this.renderDay(this.dealDateToTableData);
        }
        return (<>
        <Form.Item label={'统计维度'}>
          {getFieldDecorator('statisticalDimension1', {
            initialValue: statisticalDimension,
        })(<Radio.Group onChange={this.changeDateType}>
              {statisticalDimensionList.map((v) => (<Radio value={v.value} key={`${v.name}_${v.value}`}>{v.name}</Radio>))}
            </Radio.Group>)}
        </Form.Item>
        <Form.Item label={'日期范围'} wrapperCol={{ span: 20 }} required={false}>
          {DateSelect}
        </Form.Item>
        <Form.Item label={'拍卖类型'}>
          {getFieldDecorator('auctionMode', {
            initialValue: `${auctionMode || ''}`,
        })(<Select getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
              {sessionType.map((v) => (<Select.Option value={v.keyName} key={v.keyName}>{v.value}</Select.Option>))}
            </Select>)}
        </Form.Item>
      </>);
    }
    // desc 数据维度：场次
    renderSession() {
        const { sessionCheckedList, } = this.props.report;
        return (<Form.Item label={'拍卖场次'} wrapperCol={{ span: 14 }}>
        <Button type={'primary'} onClick={() => {
            dispatch.reportCreate.openSessionCheck({});
        }}>
          <Icon type="plus"/>
          添加
        </Button>
        <RowCol layout={2}>
          {sessionCheckedList.length > 0 && sessionCheckedList.map((item, index) => (<SessionItem sessionCode={item.sessNum} key={item.sessNum} onClick={() => {
            dispatch.reportCreate.cancelHasShowSession([item]);
        }}/>))}
        </RowCol>
      </Form.Item>);
    }
    // desc 数据维度：车商
    renderCarBusiness() {
        const { getFieldDecorator } = this.props.form;
        const { memoryData3, } = this.props.report;
        const { statisticalDimension = 5 } = memoryData3.formData;
        const { statisticalDimensionList } = this.state;
        let DateSelect;
        switch (statisticalDimension) {
            case 1:
                DateSelect = this.renderDay(this.queryCarBusinessData);
                break;
            case 2:
                DateSelect = this.renderWeek(this.queryCarBusinessData);
                break;
            case 3:
                DateSelect = this.renderMonth(this.queryCarBusinessData);
                break;
            case 4:
                DateSelect = this.renderQuarter(this.queryCarBusinessData);
                break;
            default:
                DateSelect = (<>
            <DatePicker disabled={true} style={{ width: '200px' }} placeholder={'开始时间'}/>
            <span style={{ color: '#8D8E99', margin: '0 5px' }}>～</span>
            <Form.Item label={''} style={{
                    marginBottom: 0,
                    display: 'inline-block',
                    height: '40px',
                    overflow: 'visible',
                }}>
              <DatePicker disabled={true} style={{ width: '200px' }} placeholder={'结束时间'}/>
            </Form.Item>
          </>);
        }
        statisticalDimension === 5 && this.queryCarBusinessData();
        return (<>
        <Form.Item label={'统计维度'}>
          {getFieldDecorator('statisticalDimension3', {
            initialValue: statisticalDimension,
        })(<Radio.Group onChange={this.changeDateType}>
              <Radio value={5}>截止昨天</Radio>
              {statisticalDimensionList.map((v) => (<Radio value={v.value} key={`${v.name}_${v.value}`}>{v.name}</Radio>))}
            </Radio.Group>)}
        </Form.Item>
        {DateSelect && (<Form.Item label={'日期范围'} wrapperCol={{ span: 20 }} required={false}>
              {DateSelect}
            </Form.Item>)}
      </>);
    }
    // desc 请求具体车商数据
    queryCarBusinessData() {
        setTimeout(() => {
            const { dataDimension } = this.props.report;
            const memoryData = this.props.report.memoryData3;
            const { statisticalDimension } = memoryData.formData;
            let endDate;
            let startDate;
            if (statisticalDimension === 5) {
                endDate = moment().subtract(1, 'd').format('YYYY-MM-DD');
                if (this.yesterdayDate !== endDate) {
                    this.yesterdayDate = endDate;
                }
                else {
                    dispatch.reportCreate.SET_STATE({
                        preViewTableData: memoryData.tableData,
                    });
                    return;
                }
            }
            else {
                endDate = this.props.form.getFieldsValue([`endTime${dataDimension}${statisticalDimension}`])[`endTime${dataDimension}${statisticalDimension}`];
                startDate = this.props.form.getFieldsValue([`startTime${dataDimension}${statisticalDimension}`])[`startTime${dataDimension}${statisticalDimension}`];
                if (statisticalDimension === 4) {
                    startDate = startDate.year ? moment(`${startDate.year}`).quarter(startDate.quarter).startOf('quarter').format('YYYY-MM-DD') : undefined;
                    endDate = endDate.year ? moment(`${endDate.year}`).quarter(endDate.quarter).startOf('quarter').format('YYYY-MM-DD') : undefined;
                }
                else {
                    endDate && endDate.format && (endDate = endDate.format('YYYY-MM-DD'));
                    startDate && startDate.format && (startDate = startDate.format('YYYY-MM-DD'));
                }
                if (!(startDate && endDate)) {
                    return;
                }
            }
            dispatch.reportCreate.queryCarBusiness({
                endDate,
                startDate,
            });
        });
    }
    renderCheckbox(title, list) {
        return (<div className={configStyle.check_item}>
        <div className={configStyle.check_title}>{title}</div>
        <RowCol className={configStyle.check_row} layout={2}>
          {list.map((v) => (<Checkbox onChange={this.changeTableShow} className={configStyle.checkbox} value={v.value} key={`${v.label}_${v.value}`} disabled={v.disabled}>
              {v.label}
            </Checkbox>))}
        </RowCol>
      </div>);
    }
    // desc 列表显示项
    renderCheckGroup() {
        const { listDisplayItems, dataDimension } = this.props.report;
        const checkBoxValue = listDisplayItems;
        let radioGroup;
        switch (dataDimension) {
            case 1:
                radioGroup = this.renderTanantCheckGroup();
                break;
            case 2:
                radioGroup = this.renderSessionCheckGroup();
                break;
            case 3:
                radioGroup = this.renderCarBusinessCheckGroup();
                break;
        }
        return (<Checkbox.Group value={checkBoxValue} className={configStyle.check_group}>
        {radioGroup}
      </Checkbox.Group>);
    }
    renderTanantCheckGroup() {
        const { sessionStatic, dealData, goldData, buyerData } = this.props.report;
        return (<>
        {this.renderCheckbox('场次统计', setKey(sessionStatic))}
        {this.renderCheckbox('交易数据', setKey(dealData))}
        {this.renderCheckbox('资金数据', setKey(goldData))}
        {this.renderCheckbox('经销商数据', setKey(buyerData))}
      </>);
    }
    renderSessionCheckGroup() {
        const { dealData, goldData, buyerData } = this.props.report;
        return (<>
        {this.renderCheckbox('交易数据', setKey(dealData))}
        {this.renderCheckbox('资金数据', setKey(goldData))}
        {this.renderCheckbox('经销商数据', setKey(buyerData))}
      </>);
    }
    renderCarBusinessCheckGroup() {
        const { dealDataCar, sellerData } = this.props.report;
        return (<>
        {this.renderCheckbox('经销商数据', setKey(sellerData))}
        {this.renderCheckbox('交易数据', setKey(dealDataCar))}
      </>);
    }
    // desc 切换数据维度
    changeDataType(event) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.memoryDataFn();
            const type = event.target.value;
            dispatch.reportCreate.SET_STATE({
                dataDimension: type,
            });
            dispatch.reportCreate.changeDataDimension(type);
        });
    }
    // desc 记忆数据
    memoryDataFn() {
        const { dataDimension } = this.props.report;
        const memoryData = this.props.report[`memoryData${dataDimension}`];
        const { statisticalDimension } = memoryData.formData;
        const formData = this.props.form.getFieldsValue();
        let endDate = formData[`endTime${dataDimension}${statisticalDimension}`];
        let startDate = formData[`startTime${dataDimension}${statisticalDimension}`];
        if (statisticalDimension === 4) {
            startDate = startDate.year ? moment(`${startDate.year}`).quarter(startDate.quarter).startOf('quarter').format('YYYY-MM-DD') : undefined;
            endDate = endDate.year ? moment(`${endDate.year}`).quarter(endDate.quarter).startOf('quarter').format('YYYY-MM-DD') : undefined;
        }
        else {
            endDate && endDate.format && (endDate = endDate.format('YYYY-MM-DD'));
            startDate && startDate.format && (startDate = startDate.format('YYYY-MM-DD'));
        }
        formData[`startTime${dataDimension}${statisticalDimension}`] = startDate;
        formData[`endTime${dataDimension}${statisticalDimension}`] = endDate;
        dispatch.reportCreate.SET_STATE({
            [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                formData: Object.assign(Object.assign({}, memoryData.formData), formData),
            }),
        });
    }
    // desc 切换统计维度
    changeDateType(event) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.memoryDataFn();
            const type = event.target.value;
            const { dataDimension = 1 } = this.props.report;
            const memoryData = this.props.report[`memoryData${dataDimension}`];
            const formData = memoryData.formData;
            dispatch.reportCreate.SET_STATE({
                [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                    formData: Object.assign(Object.assign({}, formData), { statisticalDimension: type }),
                    tableData: [],
                }),
                preViewTableData: [],
            });
            dataDimension === 1 && this.dealDateToTableData();
            if (dataDimension === 3) {
                this.queryCarBusinessData();
            }
        });
    }
    // desc 切换预览展示列
    changeTableShow(event) {
        const { value, checked } = event.target;
        dispatch.reportCreate.changeShowItem({
            itemKey: value,
            checked,
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { reportFormName, dataDimension = 1, } = this.props.report;
        const { dataDimensionList } = this.state;
        return (<div className={configStyle.config_view}>
        <div className={configStyle.header}>
          <span className={configStyle.configTitle}>信息设置</span><span>(必填)</span>
        </div>
        <Form layout={'horizontal'} labelCol={{ span: 3 }} wrapperCol={{ span: 14 }} labelAlign={'left'} colon={false}>
          <Form.Item label={'报表名称'} required={false}>
            {getFieldDecorator('reportFormName', {
            initialValue: reportFormName,
            rules: [
                {
                    required: true,
                    message: '请输入报表名称',
                },
                {
                    validator: CHECK_name(20),
                },
            ],
        })(<Input onChange={(event) => {
            const name = event.target.value;
            dispatch.reportCreate.SET_STATE({
                reportFormName: name,
            });
        }} placeholder={'请输入报表名称'}/>)}
          </Form.Item>
          <Form.Item label={'数据维度'}>
            {getFieldDecorator('dataDimension', {
            initialValue: dataDimension,
        })(<Radio.Group onChange={this.changeDataType}>
                {dataDimensionList.map((v) => (<Radio value={v.value} key={`${v.name}_${v.value}`}>{v.name}</Radio>))}
              </Radio.Group>)}
          </Form.Item>
          {dataDimension === 1 && this.renderTanant()}
          {dataDimension === 2 && this.renderSession()}
          {dataDimension === 3 && this.renderCarBusiness()}
        </Form>
        <div className={configStyle.check_item} style={{ margin: 0 }}>列表显示项</div>
        {this.renderCheckGroup()}
        <ReportModal />
      </div>);
    }
}
export default connect(mapStateToProps, null, null, { forwardRef: true })(Form.create()(ReportConfig));
